import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'
import { Parallax } from 'react-scroll-parallax'

export interface Props {
  images: ImageProps[]
}

export const Carousel = memo(function Carousel({ images }: Props) {
  const [animObjectRef, isAnimObjectVisible] = useInView({
    triggerOnce: true,
  })

  return (
    <Container
      className={isAnimObjectVisible ? 'visible' : undefined}
      dial={2}
      ref={animObjectRef}
      row
    >
      {images.map((item, index) => (
        <Box key={index}>
          <Parallax translateX={['-10%', '0%']}>
            <Image {...item} />
          </Parallax>
        </Box>
      ))}
    </Container>
  )
})

const Box = styled.div`
  aspect-ratio: 0.92;
  width: calc(33.333% - 3.5rem);
  max-height: 43.75rem;
  margin: 0 3.889vw;
  clip-path: inset(0% 0% 100% 0%);
  overflow: hidden;
  position: relative;
  transition: 1.4s 0.6s ease-in-out;

  > div {
    width: 110%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
`

const Container = styled(FlexBox)`
  margin: -15.625rem -29% 0;
  overflow: hidden;
  z-index: 2;
  &.visible {
    ${Box} {
      clip-path: inset(0);
    }
  }
`
